import React, { useCallback } from 'react'

import { DriverAutocomplete } from '@/components/common/DriverAutocomplete'
import { Card, CardContent } from '@/components/ui/Card'
import { DateRangePicker } from '@/components/ui/DateRangePicker'
import { useAnalyticsStore } from '@/store/analytics.store'
import type { Driver } from '@/types/driver'

export function AnalyticsFilters() {
  const { filters, setFilters } = useAnalyticsStore()

  const rangeValue = React.useMemo(() => 
    filters.from && filters.to ? { start: filters.from, end: filters.to } : null, 
  [filters.from, filters.to])

  const handleDateRangeChange = useCallback((val: { start: string; end: string } | null) => {
    if (val) {
      setFilters({ from: val.start, to: val.end })
    } else {
      setFilters({ from: '', to: '' })
    }
  }, [setFilters])

  const handleDriverChange = useCallback((d: Driver | null) => {
    setFilters({ driverID: d?.ID ?? '' })
  }, [setFilters])

  return (
    <Card>
      <CardContent className="p-2">
        <div className="flex gap-6 items-center flex-wrap">
          <div className="flex-1 min-w-72">
            <DateRangePicker
              value={rangeValue}
              onChange={handleDateRangeChange}
              variant={'secondary'}
            />
          </div>
          <div className="flex-1 w-64">
            <DriverAutocomplete
              selectedId={filters.driverID}
              onSelectionChange={handleDriverChange}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
